/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';

export type IPaginationProps = {
  hasMore?: boolean;
  scrollPosition?: number;
  fetchMore?(): Promise<boolean>;
};

export function usePagination(
  loading: boolean,
  fetchMore: any,
  hasMore?: boolean,
  after?: string
) {
  const [scrollPosition, setScrollPosition] = useState<number>();

  const handlePagination = async (): Promise<boolean> => {
    if (hasMore && !loading) {
      await fetchMore({
        variables: {
          after,
        },
      });
    }
    return Promise.resolve(true);
  };

  return {
    scrollPosition,
    handlePagination,
    setScrollPosition,
  };
}
